module.exports = __webpack_public_path__ + "static/typewriter-f8d4daabfebfc0990436a060ab5fee99.png";